/**
 * This module is in charge of controlling switch visual components.
 */
(function() {

  "use strict";
  var DEFAULT_CONFIG = {
    position: 'RIGHT_BOTTOM',

  };
  var ID = 0;

  define('fg-arv/components/unitSystem',[],function() {
    var module = {
      createComponent: function(config) {
        var container = document.createElement('div');
        container.className = 'fg-arv_unitSystem-component';
        if (container) {
          var id = createDomID();
          var conf = jQuery.extend({
            id: id
          }, DEFAULT_CONFIG, config);

          var map = conf.widget.getMap();
          var controls = map.controls[google.maps.ControlPosition[conf.position]].getArray();
          if (jQuery.inArray(container, controls) !== -1) {
            container = controls[jQuery.inArray(container, controls)];
          } else {
            jQuery(container).addClass('map-control');
            container.index = 3;
            map.controls[google.maps.ControlPosition[conf.position]].push(container);
          }

          var template = createTemplate(conf);
          container.innerHTML = template;
          var value = 'imperial';

          var component = {
            getID: function() {
              return id;
            },
            init: function() {
              var componentElement = jQuery('#' + id);
              var content = '<div class="btn-group" role="group" aria-label="...">' +
                '<button type="button" class="btn btn-default imperial">Miles</button>' +
                '<button type="button" class="btn btn-default metric">Km</button>' +
                '</div>';
              componentElement.html(content);
              var metricbtn = componentElement.find('.metric');
              var imperialbtn = componentElement.find('.imperial');
              if (value === 'metric') {
                metricbtn.addClass('selected');
              } else {
                imperialbtn.addClass('selected');
              }
              metricbtn.click(function() {
                component.changeUnitSystem('metric');
                metricbtn.addClass('selected');
                imperialbtn.removeClass('selected');
              });
              imperialbtn.click(function() {
                component.changeUnitSystem('imperial');
                metricbtn.removeClass('selected');
                imperialbtn.addClass('selected');
              });

            },
            getValue: function() {
              return value;
            },
            setValue: function(type) {
              value = type;
            },
            changeUnitSystem: function(type) {
              if (type !== component.getValue()) {
                component.setValue(type);
                config.widget.unitSystem = type;
                config.widget.journeysComponent.changeUnitSystem(type, '.distance-info');
              }
            }
          };

          return component;
        }
      },
      getStyles: function() {
        return _styles;
      }
    };

    return module;

    //*********************************************************

    function createTemplate(config) {
      return "<div id='" + config.id + "' class='unitSystem'>" +
        "</div>";
    }

    function createDomID() {
      var i = ++ID;
      return "fg-arv-unitSystem-" + i;
    }

  });

})();

